import styles from "./RoleplayInfo.module.scss";

const RoleplayInfo = ({ title, info }) => {
  return (
    <div className={styles.roleplayInfoContainer}>
      {title && <span>{title}</span>}
      {info && <p>{info}</p>}
    </div>
  );
};

export default RoleplayInfo;
